<template>
    <div v-if="error" class="d-inline-block form-text text-danger">{{ error }}</div>
</template>

<script>
export default {
    props: {
        error: String
    }
}
</script>
